import React from 'react';
import { DateSelect } from '../../../components/UI-Elements/Date/DateSelect';
import { IMaterialExposure } from '../../../sp-types/netExposureType';

interface DetailsProps {
  materialExposure: IMaterialExposure;
  prevNetExposure: number;
  netExposure: number;
  //dueDate: Date;
}
export const BalanceOverviewDetails: React.FC<DetailsProps> = ({ prevNetExposure, netExposure }) => {
  return (
    <div className="flex flex-col w-[70%] gap-2">
      <div>Select due date</div>
      <div className="flex flex-row w-[70%] gap-4">
        <div className="flex flex-col">
          <div className="text-red">Previous Balance</div>
          <div>{prevNetExposure}</div>
        </div>
        <div className="flex flex-col">
          <div className="text-red">Current Balance</div>
          <div>{netExposure}</div>
        </div>
      </div>

      <div className="flex flex-row">
        <div>Due date</div>
        <div>
          <DateSelect
            selectedDate={new Date().toLocaleDateString()}
            setSelectedDate={console.log}
            mode="monthYear"
            subTitle="To"
          />
        </div>
      </div>
    </div>
  );
};
